import { render, staticRenderFns } from "./ModuleStatusBadge.vue?vue&type=template&id=00458d76&scoped=true&"
import script from "./ModuleStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ModuleStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ModuleStatusBadge.vue?vue&type=style&index=0&id=00458d76&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00458d76",
  null
  
)

export default component.exports